import { render, staticRenderFns } from "./IntegrationFormTeams.vue?vue&type=template&id=4c5993e4&scoped=true"
import script from "./IntegrationFormTeams.vue?vue&type=script&lang=js"
export * from "./IntegrationFormTeams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5993e4",
  null
  
)

export default component.exports